<template>
  <div class="product-recommendations-carousel-container">
    <ImpressionTrackingContainer
      root-margin="-15% 0% 0%"
      :threshold="[0.5]"
      @track-impression="trackCarouselImpression"
    >
      <ProductRecommendationsCarousel
        :title="title"
        :products="products"
        :entity-type="entityType"
        :products-per-view="productsPerView"
        :carousel-name="carouselName"
        @track-product-impression="trackProductImpression"
      />
    </ImpressionTrackingContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductRecommendationsCarousel from './ProductRecommendationsCarousel.vue'

export default {
  name: 'ProductRecommendationsCarouselContainer',

  components: {
    ProductRecommendationsCarousel
  },
  props: {
    title: {
      type: String,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    entityType: {
      type: String,
      required: true
    },
    productsPerView: {
      type: Number,
      default: 5
    },
    carouselName: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters({
      recommendationId: 'productRecommendations/recommendationId',
      splitKey: 'productRecommendations/splitKey',
      strategy: 'productRecommendations/strategy',
      userId: 'user/id',
      cardNumber: 'user/cardNumber'
    }),
    getTrackingParams() {
      const entitySlug =
        this.entityType === 'brand'
          ? this.$route.params.id
          : this.entityType === 'category'
          ? this.$route.path.replace('/categories/', '')
          : ''
      return {
        origin: `${this.entityType}_${entitySlug}${
          this.strategy ? `|${this.strategy}` : ''
        }`,
        recommendation_id: this.recommendationId,
        carousel_name: this.carouselName,
        card_number: this.cardNumber,
        session_id: this.$cookies.get('_ga_6KSFTBFXP6')?.split('.')[2],
        page_path: this.$route.path,
        user_id: this.userId,
        site_country: this.$i18n.countryCode.toLowerCase(),
        traffic_split_key: this.splitKey
      }
    }
  },

  methods: {
    trackCarouselImpression() {
      this.$analytics.trackEvent(
        'recommended_for_you_impression',
        this.getTrackingParams
      )
    },

    trackProductImpression(product, cardSequence) {
      this.$analytics.trackEvent('recommended_for_you_card_impression', {
        ...this.getTrackingParams,
        product_id: product.id,
        variant_id: product.featuredVariant.id,
        card_sequence_num: cardSequence
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.product-recommendations-carousel-container {
  width: 100%;
}
</style>
